import { render, staticRenderFns } from "./SettingsCategories.vue?vue&type=template&id=baa81a96&scoped=true"
import script from "./SettingsCategories.vue?vue&type=script&lang=js"
export * from "./SettingsCategories.vue?vue&type=script&lang=js"
import style0 from "./SettingsCategories.vue?vue&type=style&index=0&id=baa81a96&prod&scoped=true&lang=css"
import style1 from "./SettingsCategories.vue?vue&type=style&index=1&id=baa81a96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa81a96",
  null
  
)

export default component.exports